import type { ReactNode } from "react";

import { cn } from "@/lib/cn";

export function Skeleton({ className }: { className?: string | undefined }) {
  return <div aria-hidden className={cn("animate-pulse rounded bg-line", className)} />;
}

export function SkeletonList({
  children,
  className,
  label,
}: {
  children: ReactNode;
  className?: string | undefined;
  label: string;
}) {
  return (
    <div aria-busy="true" aria-live="polite" className={className}>
      <span className="sr-only">{label}</span>
      {children}
    </div>
  );
}
